export class Movimentation {
	releaseDate: string;
	code: number;
	description: string;
	mainValue: number;
	yeldValue: number;
	tax: number;
	liquidValue: number;
	balanceInvestValue: number;
	isApplication: boolean;
	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-extract/models/movimentation.ts